import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';
import FilterPanel from './FilterPanel';
import SortPanel from './SortPanel';
import styles from '../ManagePage.module.css';

const ManageHeader = ({
  searchHook,
  filterPanelsHook,
  filtersHook,
  sortHook,
  projectTypeFilterHook,
  getUniqueCategories
}) => {
  const { searchTerm, setSearchTerm, clearSearch } = searchHook;
  const { 
    showFilterPanel, 
    showSortPanel, 
    toggleFilterPanel, 
    toggleSortPanel,
    closeFilterPanel 
  } = filterPanelsHook;
  const {
    selectedStatuses,
    selectedCategories,
    selectedModes,
    handleStatusChange,
    handleCategoryChange,
    handleModeChange,
    clearAllFilters
  } = filtersHook;
  const { selectedSortOption, setSelectedSortOption } = sortHook;
  const { 
    selectedProjectTypes, 
    toggleSingleListing, 
    toggleBulkListing,
    toggleListingScore
  } = projectTypeFilterHook;
  const navigate = useNavigate();

  const handleDealTagClick = () => {
    navigate('/dashboard/tools/check-deal-tags', { state: { openHistory: true } });
  };

  return (
    <>
      <div className={styles.headerContainer}>
        {/* Page Title Section */}
        <div className={styles.headerTitleSection}>
          <div className={styles.headerTitle}>Manage your listing projects</div>
          <div className={styles.headerInfoBox}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.7">
                <path d="M11.6985 9.62219C7.84504 8.752 7.24815 8.1551 6.37799 4.30155C6.33812 4.12542 6.18135 4 6.00019 4C5.81904 4 5.66227 4.12542 5.6224 4.30155C4.75185 8.1551 4.15535 8.752 0.301926 9.62219C0.125415 9.66245 0 9.81884 0 10C0 10.1812 0.125415 10.3375 0.301926 10.3778C4.15535 11.2484 4.75185 11.8453 5.6224 15.6985C5.66227 15.8746 5.81904 16 6.00019 16C6.18135 16 6.33812 15.8746 6.37799 15.6985C7.24854 11.8453 7.84504 11.2484 11.6985 10.3778C11.875 10.3375 12 10.1812 12 10C12 9.81884 11.8746 9.66245 11.6985 9.62219Z" fill="url(#paint0_linear_0_7)"/>
                <path d="M15.6965 3.11959C13.635 2.65407 13.3455 2.36463 12.88 0.303467C12.8395 0.125828 12.6821 0 12.4998 0C12.3175 0 12.1601 0.125828 12.1196 0.303467C11.6541 2.36463 11.3646 2.65407 9.30347 3.11959C9.12583 3.16011 9 3.31749 9 3.49981C9 3.68212 9.12583 3.8395 9.30347 3.88002C11.3646 4.34554 11.6541 4.63498 12.1196 6.69653C12.1601 6.87378 12.3175 7 12.4998 7C12.6821 7 12.8395 6.87378 12.88 6.69653C13.3455 4.63498 13.635 4.34554 15.6965 3.88002C15.8738 3.8395 16 3.68212 16 3.49981C16 3.31749 15.8738 3.16011 15.6965 3.11959Z" fill="url(#paint1_linear_0_7)"/>
              </g>
              <defs>
                <linearGradient id="paint0_linear_0_7" x1="-4.47035e-08" y1="10" x2="11.0143" y2="16" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#2766AA"/>
                  <stop offset="1" stopColor="#0752B0"/>
                </linearGradient>
                <linearGradient id="paint1_linear_0_7" x1="9" y1="3.5" x2="15.425" y2="7" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#2766AA"/>
                  <stop offset="1" stopColor="#0752B0"/>
                </linearGradient>
              </defs>
            </svg>
            <div className={styles.headerInfoBoxText}>Organize, search, and manage all your product listings in one place</div>
          </div>
        </div>

        <div className={styles.headerRow}>
          <div className={styles.searchBarBox}>
            <div className={styles.searchBarInner}>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.421 0C14.5954 0 18 3.40462 18 7.57899C18 11.7534 14.5954 15.158 10.421 15.158C8.67422 15.158 7.06155 14.5613 5.77761 13.5621L1.61719 17.7224C1.24712 18.0925 0.647591 18.0925 0.277544 17.7224C-0.0925028 17.3524 -0.0925265 16.7519 0.277544 16.3828L4.43796 12.2234C3.43876 10.9383 2.84203 9.32678 2.84203 7.58006C2.84203 3.40569 6.24668 0.00106589 10.4211 0.00106589L10.421 0ZM10.421 1.89475C7.27068 1.89475 4.73667 4.42874 4.73667 7.57899C4.73667 10.7292 7.27068 13.2632 10.421 13.2632C13.5712 13.2632 16.1052 10.7292 16.1052 7.57899C16.1052 4.42874 13.5712 1.89475 10.421 1.89475Z" fill="#D2D2D2"/>
              </svg>
              <input
                type="text"
                placeholder="Search for Project Names, ASIN and SKU-IDs"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={`${styles.searchBarInput} ${searchTerm ? styles.searchBarInputFilled : ''}`}
              />
              {searchTerm && (
                <button
                  onClick={clearSearch}
                  className={styles.clearSearchBtn}
                >
                  <FaTimes className={styles.clearSearchBtnIcon} />
                </button>
              )}
            </div>
          </div>
          <div className={styles.filterSortButtons}>
            <button
              type="button"
              onClick={toggleFilterPanel}
              className={`${styles.headerActionButton} ${showFilterPanel ? styles.headerActionButtonActive : ''}`}
            >
              <div className={styles.headerActionButtonInner}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.6431 0H2.35692C1.05846 0 0 1.05846 0 2.35692C0 2.98462 0.246154 3.57538 0.689231 4.02462L5.53846 8.87385V14.5169C5.53846 15.3354 6.20308 16 7.02154 16C7.41538 16 7.79692 15.84 8.07385 15.5631L9.92 13.7169C10.2708 13.3662 10.4615 12.9046 10.4615 12.4123V8.86769L15.3108 4.01846C15.7538 3.57538 16 2.98462 16 2.35692C16 1.05846 14.9415 0 13.6431 0ZM14.4369 3.15077L9.59385 8C9.36 8.23385 9.23077 8.54154 9.23077 8.87385V12.4185C9.23077 12.5785 9.16308 12.7385 9.05231 12.8554L7.20615 14.7015C7.05846 14.8431 6.76923 14.72 6.76923 14.5169V8.87385C6.76923 8.54769 6.64 8.23385 6.40615 8.00615L1.56308 3.15077C1.35385 2.94154 1.23077 2.65231 1.23077 2.35692C1.23077 1.73538 1.73538 1.23077 2.35692 1.23077H13.6431C14.2646 1.23077 14.7692 1.73538 14.7692 2.35692C14.7692 2.65231 14.6462 2.94154 14.4369 3.15077Z" fill="#737373"/>
                </svg>
                <span className={styles.headerActionButtonLabel}>Filters</span>
              </div>
            </button>
            <button
              type="button"
              onClick={toggleSortPanel}
              className={`${styles.headerActionButton} ${styles.headerActionButtonSort} ${showSortPanel ? styles.headerActionButtonActive : ''}`}
            >
              <div className={`${styles.headerActionButtonInner} ${styles.headerActionButtonInnerSort}`}>
                <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M20.7733 11.2458C21.4378 10.5813 22.4471 11.5906 21.7826 12.2551L16.8374 17.2003C16.5753 17.4586 16.1264 17.4707 15.8402 17.1882L10.9081 12.2551C10.2436 11.5906 11.2529 10.5813 11.9174 11.2458L15.632 14.9605V0.714061C15.632 -0.225533 17.0596 -0.225533 17.0596 0.714061V14.9605L20.7733 11.2458ZM5.37079 0.059729L5.16261 0.198206L0.217439 5.14242C-0.447071 5.80693 0.562233 6.81624 1.22674 6.15173L4.94139 2.43708V16.6835C4.94139 17.6231 6.36891 17.6231 6.36891 16.6835L6.36798 2.43708L10.0826 6.15173C10.7471 6.81624 11.7564 5.80693 11.0919 5.14242L6.15985 0.209388C5.9526 0.0058544 5.64587 -0.0601566 5.37079 0.059729Z" fill="#737373"/>
                </svg>
                <span className={styles.headerActionButtonLabel}>Sort By</span>
              </div>
            </button>

            {showFilterPanel && (
              <FilterPanel
                selectedStatuses={selectedStatuses}
                selectedCategories={selectedCategories}
                selectedModes={selectedModes}
                categories={getUniqueCategories()}
                onStatusChange={handleStatusChange}
                onCategoryChange={handleCategoryChange}
                onModeChange={handleModeChange}
                onClearAll={clearAllFilters}
                onClose={closeFilterPanel}
              />
            )}

            {showSortPanel && (
              <SortPanel
                selectedSortOption={selectedSortOption}
                onSortChange={setSelectedSortOption}
              />
            )}
          </div>
        </div>
      </div>

      {/* Navigation buttons below search bar */}
      <div className={styles.navButtonsContainer}>
        <button
          type="button"
          className={`${styles.navButton} ${selectedProjectTypes.includes('single') ? styles.navButtonActive : ''}`}
          onClick={toggleSingleListing}
        >
          <span className={`${styles.navButtonText} ${styles.navButtonTextSingleListing}`}>Single Listing</span>
        </button>
        <button
          type="button"
          className={`${styles.navButton} ${selectedProjectTypes.includes('bulk') ? styles.navButtonActive : ''}`}
          onClick={toggleBulkListing}
        >
          <span className={`${styles.navButtonText} ${styles.navButtonTextBulkListing}`}>Bulk Listing</span>
        </button>
        <button
          type="button"
          className={`${styles.navButton} ${selectedProjectTypes.includes('listing_score') ? styles.navButtonActive : ''}`}
          onClick={toggleListingScore}
        >
          <span className={`${styles.navButtonText} ${styles.navButtonTextListingScore}`}>Listing Score</span>
        </button>
        <button
          type="button"
          className={styles.navButton}
          onClick={handleDealTagClick}
        >
          <span className={`${styles.navButtonText} ${styles.navButtonTextDealTag}`}>Deal Tag</span>
        </button>
      </div>
    </>
  );
};

export default ManageHeader;
